module.exports = __webpack_public_path__ + "img/ld-lewis.4d414efb.png";